/** Rotating tips over the input bar and the slash-command menu. */
export default {
  tipWorkDirectory: "You can ask Denker to change your project work directory",
  tipHireAgents: "Denker can help you hire agents to your project",
  tipManageProjects:
    "Denker can manage projects, like rename, list, delete, etc",
  tipTidy: "/tidy to organize and fit all frames in view",
  tipFocus:
    "/focus to expand pinned frames and notes with a left-rail navigator",
  tipReview: "/review to step through tasks with unread agent updates",
  tipBoard: "/board to open the task board",
  tipTask: "/task to switch from chat mode to create-task mode",
  tipNew: "/new to start a fresh chat",
  tipAgent: "/agent to open agents",
  tipHeart: "/heart to toggle agent heartbeat on or off",
  tipComment: "Try add comment to your frames",
  tipRemember: "Try “Remember that our target users are founders”",
  tipDeliverables:
    "You can ask agents to show you deliverables by creating frames",
  tipGmail: "Ask Denker to help you connect to Gmail",
  tipNote: "You can add note on the canvas",
  tipDelegate: "Ask Denker to delegate tasks to other agents",
  tipPasteImages: "Paste images directly into chat or comment",
  tipNewLine: "Shift+Enter adds a new line",
  tipPin: "Pin frames so /focus can surface them first",
  tipDoubleClick: "Double click any frame to zoom in",
  tipFullScreen: "Frames can be expanded to view in full screen",
  tipBoardExpand: "Task board can be expanded to view details",
  tipDragTasks: "You can drag and drop tasks in different columns",
  tipIndependentTask:
    "Ask Denker to start an independent task while you keep chatting",
  dismissTips: "Dismiss tips",
  commands: "Commands",
  skills: "Skills",
  noSkills:
    "No skills assigned to this agent. Add skills from the agent settings.",
} as const;
